module.exports = "<div id=\"echarts\" *ngIf=\"!isLoading\" echarts [initOpts]=\"initOpts\" [options]=\"chartOption\" (chartInit)=\"onChartInit($event)\"\n    [style.marginLeft.px]=\"-246\" [style.padding.px]=\"10\" [style.height.px]=\"initOpts.height\" class=\"gauge-ring\"></div>\n<div *ngIf=\"isLoading\" class=\"missing-chart\">\n    <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\n    <span class=\"sr-only\">Loading...</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/gauge-ring-chart/gauge-ring-chart.component.html
// module id = ./src/app/shared/components/chart/gauge-ring-chart/gauge-ring-chart.component.html
// module chunks = main